var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-item secondary" }, [
    _c("h5", { staticClass: "is-size-5" }, [
      _vm._v(_vm._s(_vm.$t("transactions.debtByDateTitle"))),
    ]),
    _c("div", { attrs: { id: "modifier-items" } }, [
      _c(
        "div",
        [
          _vm._v(" " + _vm._s(_vm.$t("generalWords.Date")) + ": "),
          _c("b-datepicker", {
            attrs: { "append-to-body": true, size: "is-small" },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          }),
        ],
        1
      ),
      _vm.$i18n.locale === "cl"
        ? _c("div", [
            _vm._v(" Valor UF: "),
            _vm.isLoading
              ? _c("span", { staticClass: "fas fa-spinner fa-spin" })
              : _c("div", [_vm._v("$" + _vm._s(_vm.secondaryCurrencyFactor))]),
          ])
        : _vm._e(),
      _c("div", [
        _vm._v(" " + _vm._s(_vm.$t("transactions.debtAmount")) + ": "),
        _vm.isLoading
          ? _c("span", { staticClass: "fas fa-spinner fa-spin" })
          : _c("div", [_vm._v("$" + _vm._s(_vm.amount))]),
      ]),
      _c(
        "div",
        [
          _c(
            "b-button",
            {
              class: `is-button-primary ${_vm.isLoading ? "is-loading" : ""}`,
              attrs: {
                rounded: "",
                disabled: !_vm.checkUserFeature(
                  "element.transaction-approval.button.transaction-modify"
                ),
                size: "is-small",
              },
              on: { click: _vm.updateTransaction },
            },
            [
              _vm._v(
                " Modificar " + _vm._s(_vm.$t("generalWords.transaction")) + " "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    !!_vm.errorMessage
      ? _c("div", [
          _c("p", { staticClass: "help is-danger" }, [
            _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }